<template>
    <div>
        <a-card size="small" title="通道设置">
        </a-card>
        <div style="border-bottom:1px solid #e8e8e8">
            <channelSelecter :isDisabled="false" @onChannelCodeChange="handleChannelChange"></channelSelecter>
        </div>

        <a-list :grid="{ gutter: 16, column: 3 }" :data-source="passwayList" style="margin-top:20px;">
            <a-list-item slot="renderItem" slot-scope="item">
                <a-card>
                    <div class="box_left">
                        <a-icon type="message" theme="filled"  :style="{ fontSize: '36px', color: 'rgb(21 198 105)' }" />
                    </div>
                    <div class="box_right">
                        <div class="mTitle">
                            <span>{{item.passwaytypename}}</span>
                            <a-switch style="float:right" v-model="item.checked"  @change="onChange(item)" :loading="item.loading" />
                        </div>
                        <div class="mContent">
                            <p>通道名称：<span style="font-weight:bold;">{{item.passwayname}}</span></p>
                            <p>通道编码：<span>{{item.passwaycode}}</span></p>
                        </div>
                    </div>
                </a-card>

            </a-list-item>
        </a-list>
    </div>
</template>
<script>

import channelSelecter from '../../components/channelSelecter'

export default {
    data() {
        return {
            channelcode:'',
            passwayList:[]
        };
    },
    methods: {
        onChange(item){
            console.log(item)
            item.loading = true;


            let that = this;
            let c_params = {
                urlparams: false,
                id: item.id,
                status:item.checked ? '02' : '01'
            }
            that.$store.dispatch({
                type: "mcmsmanager/updatepasswaychannel",
                params: c_params,
                showMsg: false
            }).then(() => {
                // if (res.data.success == 1) {
                //     that.message.success('修改成功')
                // }
                item.loading = false;
            }).catch(() => {
                item.loading = false;
            });
        },
        handleChannelChange(item){
            this.channelcode = item.value;
            this.getChannelBinds();
        },
        getChannelBinds(){
            let that = this;
            let c_params = {
                urlparams: false,
                channelcode: this.channelcode,
            }

            that.$store.dispatch({
                type: "mcmsmanager/getpasswaybychannel",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    that.passwayList = [];
                    let result = res.data.data;
                    if (!result) {
                        that.message.error("未查询到渠道");
                        return;
                    }
                    result.forEach(element => {
                        element.checked = element.status == '02';
                        element.loading = false;
                        that.passwayList.push(element)
                    });

                }
            }).catch(() => {

            });
        }
    },
    components:{

        channelSelecter
    },
    mounted(){

    }
};
</script>
<style scoped>
    .mBox{
        background: #fff;
        padding: 24px;
        display: flex;
    }

    .box_left{
        width: 64px;
        height: 80px;
        float: left;
    }

    .box_right{
        width: calc(100% - 64px);
        float: left;
    }

    .mTitle{
        font-size: 18px;
    }

    .mContent p{
        line-height: 30px;
        margin-top: 12px;
        margin-bottom: 0;
    }
</style>
